// components/ui/SearchLink.jsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { cn } from '../utils';

const SearchLink = ({ 
  operator, 
  value, 
  children, 
  className,
  showParens = true, // Only affects display, not search functionality
  pureSearch = false // option to just have it be a regular search
}) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    let searchQuery;
    if (pureSearch) {
      searchQuery = value;
    } else if (operator === 'from') {
      // The from: operator doesn't need parentheses
      searchQuery = `from:${value}`;
    } else {
      // Other operators need parentheses
      searchQuery = `(${operator}:${value})`;
    }
    
    // Navigate to the search URL but don't try to update the search input manually
    navigate(`/?q=${encodeURIComponent(searchQuery)}`);
    
    // Let the navigation system handle the update
    // This prevents interference with typing
  };

  return (
    <button
      onClick={handleClick}
      className={cn(
        "text-twitter-blue hover:underline focus:outline-none focus:ring-2 focus:ring-twitter-blue/20 rounded",
        className
      )}
    >
      {children || (showParens ? `(${operator}:${value})` : value)}
    </button>
  );
};

export default SearchLink;